import './styles.scss'
import { useRef, useState, useMemo, useEffect } from 'react'
import classNames from 'classnames'
// import { useClickAway } from 'react-use'
import Map from '../Map/'
import { Link } from 'react-router-dom'
import useMapDimensions from '../hooks/useMapDimensions'
import { GroveGraph, useGroveTimelineAnimation } from '../GroveTimelineChart/'

const IntroIntro = (props) => {
  const { startIntro, grovesReady, fadeInStep, closingIntro } = props
  const modalRef = useRef()

  useEffect(() => {
    window.document.body.classList.add('hideTitle')

    return () => {
      window.document.body.classList.remove('hideTitle')
    }
  }, [])

  return (
    <div className={classNames("IntroIntro", { closingIntro })} style={{ opacity: fadeInStep < 1 ? 0 : 1}}>
      <div
        className='IntroIntroModal'
        ref={modalRef}
        style={{ opacity: fadeInStep < 2 ? 0 : 1}}
        aria-label='Main copy'
      >
        <div className='copy' style={{ opacity: fadeInStep < 3 ? 0 : 1}}>
          <h1>Dedicated Groves</h1>
          <h2>A tribute that lasts as long as the redwoods.</h2>
          <p>Remember the moment you first looked up at a redwood tree and felt in awe of nature? Keep that feeling (and your memories) alive for millennia.</p>
          <p>Whether you are looking to honor your own connection to the redwoods or that of a loved one, your generous gift will protect the redwood forest for generations to come. </p>
        </div>
        <button className={classNames('button', { disabled: !grovesReady})} onClick={startIntro} style={{ opacity: fadeInStep < 4 ? 0 : 1}}>Explore Groves</button>
      </div>
    </div>
  )
}

export default function Intro(props) {
  const { groveData, setHeaderVisible } = props
  const grovesReady = groveData && groveData.groves
  const [mapLoaded, setMapLoaded] = useState(false)

  const [introStarted, setIntroStarted] = useState(false)

  const {
    year: yearValue,
    yearRounded: yearValueRounded,
    yearExtent,
    done,
    replayCount,
    replay,
    skip,
    copyBlocks,
  } = useGroveTimelineAnimation({
    groveData,
    playing: introStarted && mapLoaded,
  })

  const grovesOfYear = useMemo(() => {
    if (!groveData) return []
    return groveData.groves.filter(grove => grove.yearDedicated <= yearValueRounded)
  }, [groveData, yearValueRounded])

  const [closingIntro, setClosingIntro] = useState(false)

  const startIntro = () => {
    setClosingIntro(true)
    setFadeInStep(3)
    setTimeout(() => {
      setFadeInStep(2)
      setTimeout(() => {
        setFadeInStep(1)
        setTimeout(() => {
          setFadeInStep(0)
          setTimeout(() => {
            setIntroStarted(true)
          }, 1200)
        }, 210)
      }, 510)
    }, 410)
  }
  const { stackMaps, mapWidth, mapHeight } = useMapDimensions()

  let intro = null

  let yearGroves = grovesOfYear
  let groveCount = grovesOfYear.length || 2

  const [fadeInStep, setFadeInStep] = useState(0)
  useEffect(() => {
    setTimeout(() => {
      setHeaderVisible(true)
      setFadeInStep(1)
      setTimeout(() => {
        setFadeInStep(2)
        setTimeout(() => {
          setFadeInStep(3)
          setTimeout(() => {
            setFadeInStep(4)
          }, 500 + 300)
        }, 200)
      }, 1.2 * 1000)
    }, 100)
  }, [setHeaderVisible])

  if (grovesReady && introStarted) {
    intro = (
      <div className={classNames( "IntroContent", { stackMaps })}>
        <Map
          width={mapWidth}
          height={mapHeight}
          mapLoaded={mapLoaded}
          setMapLoaded={setMapLoaded}
          groves={yearGroves}
          interactable={done}
          inIntro
        />
        <div className='stats'>
          <div className='facts'>
            <div className='fact'>
              <div className='label'>Year</div>
              <div className='value'>{yearValueRounded}</div>
            </div>
            <div className='fact'>
              <div className='label'>Dedicated Groves</div>
              <div className='value'>{groveCount.toLocaleString()}</div>
            </div>
          </div>
          <div className='copy'>
            With our donors' support, Save the Redwoods League has protected more than 216,000 acres of redwood forest and surrounding lands and helped create 66 redwood parks and reserves for everybody to enjoy. Today, more than 1,000 redwood groves have been dedicated in these special places.
          </div>
          <div className='buttons'>
            {
              !done ?
              <button className='button' onClick={skip}>Skip</button> :
              <Link to='find-a-grove' className='button'>Find A Grove</Link>
            }
            <button className='button' onClick={replay}>Replay</button>
          </div>
          {
            mapWidth > 400 ?
              <GroveGraph key={replayCount} width={mapWidth - 64 - 20} yearExtent={yearExtent} year={yearValue} groves={groveData} copyBlocks={copyBlocks} />
            : null
          }
        </div>
      </div>
    )
  }
  return (
    <div className='Intro'>
      {!introStarted ? <IntroIntro fadeInStep={fadeInStep} grovesReady={grovesReady} startIntro={startIntro} closingIntro={closingIntro} /> : null}
      {intro}
    </div>
  )
}
